import {isDefined} from '@/utils/typeGuards/isDefined';

export const redirectTo = (url?: string | null) => {
    if (!isDefined(url)) {
        return;
    }

    window.location.href = url;
};
